import { Component, Input, ChangeDetectionStrategy, OnInit, OnChanges } from '@angular/core';

import { Category, FinnairBoundItem, FinnairPassengerItem } from '../../api/models';
import { FinnairServiceItemWithUpsell } from '../../interfaces';
import { getCheckedBaggageSummary, getMealSummary } from '../../utils';

interface ServiceSummary {
  quantity?: number;
  description: string;
}

@Component({
  selector: 'fin-included-product-item-summary',
  templateUrl: './included-product-item-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductItemSummaryComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  protected readonly Category = Category;
  protected otherServicesSummary: ServiceSummary[] = [];
  protected bagsServicesSummary: ServiceSummary[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    switch (this.service?.category) {
      case Category.BAGGAGE:
        this.bagsServicesSummary = getCheckedBaggageSummary(this.bound, this.service);
        break;
      case Category.MEAL:
        this.otherServicesSummary = [getMealSummary(this.bound, this.service)];
        break;
    }
  }
}
